import { computed, toValue, type MaybeRefOrGetter } from 'vue';
import { useEvidenceUploadQueue } from '@/hooks/use-evidence-upload-queue';
import type { UnsentDamage } from '@/utils/evidence-upload-queue';

export type UnsentDamageRow = UnsentDamage & { lastError: string | null };

/** Unsent damages of a car on this device; a handover or return cannot move past them. */
export function useUnsentDamages(carId: MaybeRefOrGetter<string | undefined>) {
  const { items } = useEvidenceUploadQueue();
  const unsentDamages = computed<UnsentDamageRow[]>(() =>
    items.value.flatMap((item) =>
      item.damage && item.damage.carId === toValue(carId)
        ? [{ ...item.damage, lastError: item.lastError }]
        : [],
    ),
  );
  const hasUnsentDamages = computed(() => unsentDamages.value.length > 0);
  return { unsentDamages, hasUnsentDamages };
}
